
export function saveEditedData(scorecardData, formvalue, riskFactors, sectionList) {
    let flag = false
    let financialData = []
    let nonFinancialData = []
    if (formvalue.financialRiskFactorList) {
        riskFactors.financialFactors.forEach((value) => {
            if (formvalue.financialRiskFactorList[value.id]) {
                let newObj = {
                    id: value.id,
                    name: value.name,
                    assignedWeight: formvalue.financialRiskFactorList[value.id]
                }
                financialData = [...financialData, newObj]
            }
        })
        formvalue.financialRiskFactorList = financialData
    }

    if (formvalue.nonFinancialRiskFactorList) {
        riskFactors.nonFinancialFactors.forEach((value) => {
            if (formvalue.nonFinancialRiskFactorList[value.id]) {
                let newObj = {
                    id: value.id,
                    name: value.name,
                    assignedWeight: formvalue.nonFinancialRiskFactorList[value.id]
                }
                nonFinancialData = [...nonFinancialData, newObj]
            }
        })
        formvalue.nonFinancialRiskFactorList = nonFinancialData
    }

    // formvalue.productId = formvalue.id
    formvalue.sectionList = sectionList
    formvalue.enabled = true
    formvalue.id = scorecardData.id ? scorecardData.id : ""
    formvalue.name = scorecardData.name ? scorecardData.name : null
    scorecardData = formvalue
    flag = true
    return scorecardData
}

export function findEditData(data) {
    let newData = {
        financialRiskFactorList: {},
        nonFinancialRiskFactorList: {}
    }
    if (data.financialRiskFactorList) {
        data.financialRiskFactorList.forEach((value) => {
            if (value.id) {
                newData.financialRiskFactorList[value.id] = value.assignedWeight
            }
        })
    }
    if (data.nonFinancialRiskFactorList) {
        data.nonFinancialRiskFactorList.forEach((value) => {
            if (value.id) {
                newData.nonFinancialRiskFactorList[value.id] = value.assignedWeight
            }
        })
    }
    newData.riskGrades = data.riskGrades
    return newData
}